module.exports = __webpack_public_path__ + "static/media/industrial-multi-tenant.0e004ed1.svg";